module.exports = __webpack_public_path__ + "img/collection-weddingRingsWaveDesign.378a63d.webp";